import { KeyValue } from "@/main/models/common";
import { ReportTemplateTypes, ReportTemplateActionTypes } from "./reportTemplateTypes";
import { ReportTemplateDomainRequest } from "@/main/models/request";

export function getReportTemplateDomain(
	request: ReportTemplateDomainRequest,
	keyReducer: string = "default",
): ReportTemplateActionTypes {
	return {
		type: ReportTemplateTypes.GET_REPORT_TEMPLATE_DOMAIN,
		payload: { request, keyReducer },
	};
}

export function saveReportTemplateDomain(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): ReportTemplateActionTypes {
	return {
		type: ReportTemplateTypes.SAVE_REPORT_TEMPLATE_DOMAIN,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerReportTemplate(): ReportTemplateActionTypes {
	return {
		type: ReportTemplateTypes.RESET_REDUCER_REPORT_TEMPLATE,
	};
}
